import React, { Component } from 'react';
import isFunction from 'lodash/isFunction';
import { CustomLabelMessageStamps } from '../../data/settings';
import ShipStationModule from '../../shipstation';
import UI from '../../ui';
import Util from '../Util';
import Utils from '../../utils';
import OrdersMarketingView from './OrdersMarketingView.component';
import { Capability } from '../../data/account';
import OrdersUpgradeView from './OrdersUpgradeView.component';

const { ShipStation } = ShipStationModule;
const {
	WrappedRadioButton,
	WrappedInputTextWithLabel,
	WrappedDropdown,
	WrappedTooltip,
	WrappedButton,
} = UI;
const { Session, withLayoutAndModalContexts } = Utils;

class LabelMessagesView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			printReferenceNumbers: '0',
			message1: '',
			message2: '',
			message3: '',
		};
	}

	async componentDidMount() {
		await ShipStation.getLookup();

		const { PrintReferenceNumbers = '0' } = Session.getPreferences();
		const ShipStationSettings = ShipStation.getSettings();

		this.setState({
			printReferenceNumbers: PrintReferenceNumbers,
			message1: ShipStationSettings.RubberStamp1 || '',
			message2: ShipStationSettings.RubberStamp2 || '',
			message3: ShipStationSettings.RubberStamp3 || '',
		});
	}

	buildCustomLabelMessages = newValue => {
		const newPreferences = { ...this.state, ...newValue };
		const { message1, message2, message3 } = newPreferences;

		const saveSettingsParam = [
			message1 ? `RubberStamp1=${message1}` : '',
			message2 ? `RubberStamp2=${message2}` : '',
			message3 ? `RubberStamp3=${message3}` : '',
		]
			.filter(i => i !== '')
			.join('&');

		return saveSettingsParam;
	};

	customDropdownTooltip = ({ value, label, tooltip }) => {
		if (!value) {
			return label;
		}

		return (
			<>
				<div className="custom-dropdown-label">{label}</div>
				<WrappedTooltip
					tooltip={tooltip}
					target="custom-dropdown-label"
					position="bottom"
				/>
			</>
		);
	};

	onChangeInput = ({ target: { name, value } }) => {
		const { showError } = this.context;
		const newValue = {
			[name]: value,
		};

		if (name.startsWith('dropdown')) {
			const dropdownName = name.split('-')[1];
			const { [dropdownName]: prevValue } = this.state;
			newValue[dropdownName] = `${prevValue}${prevValue.length > 0 ? ' ' : ''}${value}`;
		}

		// save radio button change
		if (name === 'printReferenceNumbers') {
			Util.saveNewPreferences(newValue, showError);
		} else {
			// save message change from text/dropdown input
			Util.saveOrdersPreferences(this.buildCustomLabelMessages(newValue), showError);
		}

		this.setState(newValue);
	};

	onClickDone = () => {
		const { completionCallback } = this.props;

		if (isFunction(completionCallback)) {
			completionCallback({ close: true });
		}
	};

	render() {
		const { printReferenceNumbers, message1, message2, message3 } = this.state;
		const {
			layoutContext: { isMobile },
		} = this.props;

		const mobileCls = isMobile ? 'mobile-view' : '';
		const disableMessages = printReferenceNumbers !== '2';

		if (!Session.hasCapability(Capability.CanUseOrders)) {
			return <OrdersUpgradeView />;
		}

		return (
			<div className="settings-orders-label-messages-view">
				<div className="settings-body">
					<div
						className="settings-content-header"
						data-qa="settingsLabelCustomization-labelMessages-header"
						{...{ dataqa: 'settingsLabelCustomization-labelMessages-header' }}
					>
						<p>Label Message Settings</p>
						<hr />
					</div>
					<div className="p-grid p-dir-col p-col-12">
						<div
							className="p-col-12 instructions"
							data-qa="settingssettingsLabelCustomization-customize-text"
							{...{ dataqa: 'settingssettingsLabelCustomization-customize-text' }}
						>
							Customize what messages, if any, print on a shipping label.
						</div>
						<div className="p-col-12 choice-row">
							<div className="label-choice">
								<WrappedRadioButton
									inputId="settings-dont-print-message"
									name="printReferenceNumbers"
									value="0"
									onChange={this.onChangeInput}
									checked={printReferenceNumbers === '0'}
									dataqa="settingsLabelCustomization-dontPrintMessages"
								>
									Don't print any message on label
								</WrappedRadioButton>
							</div>
							<div className="label-choice">
								<WrappedRadioButton
									inputId="settings-print-reference-number"
									name="printReferenceNumbers"
									value="1"
									onChange={this.onChangeInput}
									checked={printReferenceNumbers === '1'}
									dataqa="settingsLabelCustomization-printReference"
								>
									Print Reference # on label
								</WrappedRadioButton>
							</div>
							<div className="label-choice">
								<WrappedRadioButton
									inputId="settings-print-custom-label"
									name="printReferenceNumbers"
									value="2"
									onChange={this.onChangeInput}
									checked={printReferenceNumbers === '2'}
									dataqa="settingsLabelCustomization-printCustom"
								>
									Print custom label messages
								</WrappedRadioButton>
							</div>
						</div>
						<div className="p-col-12">
							<p
								className="message-explanation"
								data-qa="settingsLabelCustomization-customLabelMessages-header"
								{...{
									dataqa: 'settingsLabelCustomization-customLabelMessages-header',
								}}
							>
								Define up to 3 custom messages to print on your shipping label. You
								can enter static content, use the menus to insert dynamic
								order-specific variables, or both.{' '}
								<b>Each message is limited to 50 characters.</b>
							</p>
						</div>
						<div className="p-col-12">
							<div className="p-col-9">
								<WrappedInputTextWithLabel
									className={`message-input-wrapper ${
										disableMessages ? 'disabled' : ''
									} ${mobileCls}`}
									label="Message #1"
									uiElementConfig={{
										className: 'message-input',
										name: 'message1',
										value: message1,
										onChange: this.onChangeInput,
										maxLength: '50',
										dataqa: 'settingsLabelCustomization-message1',
										disabled: disableMessages,
									}}
								/>
							</div>
							<div className="p-col-3">
								<WrappedDropdown
									className="message-dropdown"
									panelClassName="message-panel"
									name="dropdown-message1"
									options={CustomLabelMessageStamps}
									optionLabel="label"
									optionValue="value"
									placeholder="Insert Variable"
									onChange={this.onChangeInput}
									itemTemplate={this.customDropdownTooltip}
									dataqa="settingsLabelCustomization-message1"
									disabled={disableMessages}
								/>
							</div>
						</div>
						<div className="p-col-12">
							<div className="p-col-9">
								<WrappedInputTextWithLabel
									className={`message-input-wrapper ${
										disableMessages ? 'disabled' : ''
									} ${mobileCls}`}
									label="Message #2"
									uiElementConfig={{
										className: 'message-input',
										name: 'message2',
										value: message2,
										onChange: this.onChangeInput,
										maxLength: '50',
										dataqa: 'settingsLabelCustomization-message2',
										disabled: disableMessages,
									}}
								/>
							</div>
							<div className="p-col-3">
								<WrappedDropdown
									className="message-dropdown"
									panelClassName="message-panel"
									name="dropdown-message2"
									options={CustomLabelMessageStamps}
									optionLabel="label"
									optionValue="value"
									placeholder="Insert Variable"
									onChange={this.onChangeInput}
									itemTemplate={this.customDropdownTooltip}
									dataqa="settingsLabelCustomization-message2"
									disabled={disableMessages}
								/>
							</div>
						</div>
						<div className="p-col-12">
							<div className="p-col-9">
								<WrappedInputTextWithLabel
									className={`message-input-wrapper ${
										disableMessages ? 'disabled' : ''
									} ${mobileCls}`}
									label="Message #3"
									uiElementConfig={{
										className: 'message-input',
										name: 'message3',
										value: message3,
										onChange: this.onChangeInput,
										maxLength: '50',
										dataqa: 'settingsLabelCustomization-message3',
										disabled: disableMessages,
									}}
								/>
							</div>
							<div className="p-col-3">
								<WrappedDropdown
									className="message-dropdown"
									panelClassName="message-panel"
									name="dropdown-message3"
									options={CustomLabelMessageStamps}
									optionLabel="label"
									optionValue="value"
									placeholder="Insert Variable"
									onChange={this.onChangeInput}
									itemTemplate={this.customDropdownTooltip}
									dataqa="settingsLabelCustomization-message3"
									disabled={disableMessages}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="settings-content-footer">
					<WrappedButton
						className="settings-button"
						label="Done"
						type="button"
						onClick={this.onClickDone}
						dataqa="savesettings"
					/>
				</div>
			</div>
		);
	}
}

export default withLayoutAndModalContexts(LabelMessagesView);
